import { render, staticRenderFns } from "./SalesReportPage.vue?vue&type=template&id=a650854c&scoped=true"
import script from "./SalesReportPage.vue?vue&type=script&lang=js"
export * from "./SalesReportPage.vue?vue&type=script&lang=js"
import style0 from "./SalesReportPage.vue?vue&type=style&index=0&id=a650854c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a650854c",
  null
  
)

export default component.exports